import { datasetFactory } from '@fusioncharts/core/src/lib';
import SunburstDataset from '../dataset/sunburst';

const depthFirstVisit = function (arr) {
  let sumOfVisit = 0;
  arr.forEach(c => {
    let givenValue = c.value ? (+c.value) : 0,
      applicableValue = c.category.length > 0 ? depthFirstVisit(c.category) : givenValue;

    if (applicableValue > givenValue) {
      c.value = applicableValue;
    } else {
      c.value = givenValue;
      applicableValue = givenValue;
    }

    sumOfVisit += applicableValue;
  });

  return sumOfVisit;
};

/**
 * function to  create dataset, group manager.
 * assign dataset to group manager.
 **/
export default (chart) => {
  let categories = chart.getFromEnv('parsedDataSource') || [],
    length;

  categories.forEach(function depthFirstVisitRunner (e) {
    let sum = depthFirstVisit(e.category);
    !e.value && (e.value = 0);
    if (sum > (+e.value)) {
      e.value = sum;
    }
  });

  chart.config.categories = categories;
  length = categories.length;

  // if the data has no categories in them.
  if (!length) {
    chart.setChartMessage();
    return;
  }

  datasetFactory(chart, SunburstDataset, 'dataset', length, [{
    inputTree: categories
  }]);
};
